import { getClientConfig } from "../../config/clientConfig";

export const CheckUploadPermission = async () => {
  try {
    const clientConfig = getClientConfig();
    // const response = await fetch(
    //   `${clientConfig.invoice_extractor_api_url}/api/v1/health`,
    // );
    //NOTE: Since the invoice extractor API is not yet available with HTTPS, we are mocking the response here.
    // Replace this with the actual API call(above 3 rows )) when it's ready.
    const response = {
      status: 200,
    };
    return response.status === 200;
  } catch (error) {
    return false;
  }
};
